import type { LandIqDataRunEstimate } from '@immo/api-contract';

const MS_PER_MINUTE = 60_000;

/** LandIQ states estimates in minutes; the admin formats every duration from milliseconds. */
export function minutesToMs(minutes: number): number {
  return minutes * MS_PER_MINUTE;
}

/**
 * Where a run stands against its estimate. LandIQ's `overEstimate` decides OVER; a running run under it has the
 * negated overrun left. A finished run under its estimate, or a running one exactly on it, is WITHIN.
 */
export type EstimateStanding =
  | { readonly kind: 'OVER'; readonly overrunMinutes: number; readonly percent: number }
  | { readonly kind: 'LEFT'; readonly leftMinutes: number }
  | { readonly kind: 'WITHIN' };

export function estimateStanding(estimate: LandIqDataRunEstimate, running: boolean): EstimateStanding {
  if (estimate.overEstimate) {
    return { kind: 'OVER', overrunMinutes: estimate.overrunMinutes, percent: Math.round(estimate.overrunRatio * 100) };
  }

  if (running && estimate.overrunMinutes < 0) return { kind: 'LEFT', leftMinutes: -estimate.overrunMinutes };

  return { kind: 'WITHIN' };
}
